import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { fakeTableList, required, schema, stepper } from "./parts";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { Box } from "@mui/material";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { useNavigate } from "react-router";
import { BusinessContext } from "../../context/businessContext";
import { IAPI_RET005_Request } from "../../type/apiType";
import { httpAPI_RET005 } from "./api/request.formdata";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../context/globalContext";
import { API_RET005_BuildReqParams } from "../../utils/buildRequestParams";
import _ from "lodash";
import {
  DemanderKbn,
  FormClassRetire,
  FormKbn,
} from "../../assets/data/Constants";

/**
 * SCRR0411126 退職手当金受領者の変更手続き（本人確認の書類の添付）
 * @return SCRR0411126 退職手当金受領者の変更手続き（本人確認の書類の添付）
 */
const SCRR411126 = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [ruleSchema, setRuleSchema] = useState({ ...schema });
  const context = businessState.job_41;
  const [selectedValue, setSelectedValue] = useState("");
  const { state, setState } = useContext(GlobalContext);

  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  useEffect(() => {
    let resArr = stateFakeTableList.current;

    //確認する書類の選択
    let identifyDocsKind = resArr.find(
      (item) => item.keyword === "identifyDocsKind"
    )!;
    identifyDocsKind.onGetValue = handleChange;
    identifyDocsKind.setDefaultValue = context?.identificationDocsKind;
    setSelectedValue(context?.identificationDocsKind ?? "");

    context?.fileList?.forEach((item) => {
      let targetObj = resArr.find((i) => i.id === item.formClass);

      if (targetObj) {
        targetObj.setDefaultValue = [
          {
            formName: item.formName,
            fileBase64: item.file,
          },
        ];
      }
    });
    let identityDocs = context?.fileList?.filter(
      (item) => item.formClass === FormClassRetire["本人確認書類"]
    );
    identityDocs?.forEach((item, index) => {
      let targetObj = resArr.find(
        (i) => i.keyword === "identityDocs" + (index + 1)
      )!;

      targetObj &&
        (targetObj.setDefaultValue = [
          {
            formName: item.formName,
            fileBase64: item.file,
          },
        ]);
    });

    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (data: any) => {
    setSelectedValue(data);
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;

    //setRuleSchema(getSchema(currentCase));

    let resArrFile = resArr.filter(
      (item) => item.keyword !== "identifyDocsKind"
    );
    let stateSchema: any = { ...schema };
    resArrFile.forEach((item) => {
      if (item.keyword === "deceasedRetireeNumCheckDoc") {
        item.showLine =
          !!selectedValue && context?.demanderKbn === DemanderKbn["遺族"];
        stateSchema[item.keyword!] =
          !!selectedValue && context?.demanderKbn === DemanderKbn["遺族"]
            ? required
            : {};
      } else if (!item.docsKind) {
        item.showLine = !!selectedValue;
      } else {
        item.showLine = item.docsKind?.includes(selectedValue);
        stateSchema[item.keyword!] = item.docsKind?.includes(selectedValue)
          ? required
          : {};
      }
    });

    setRuleSchema({ ...stateSchema });
    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  const makeFileObj = (obj: any) => {
    const formClassList: any = [
      FormClassRetire["本人確認書類"],
      FormClassRetire["本人確認書類（表面）"],
      FormClassRetire["本人確認書類（裏面）"],
      FormClassRetire["個人番号を確認する書類"],
      FormClassRetire["振込先口座が確認できる書類"],
      FormClassRetire["死亡した退職者の個人番号を確認する書類"],
    ];
    const baseFileList =
      context?.fileList
        ?.filter?.((item) => !formClassList.includes(item?.formClass))
        ?.filter(Boolean) ?? [];

    const nextFileList = [...baseFileList];

    stateFakeTableList.current
      .filter((item) => item.type === "fileUpload" && item.showLine)
      .forEach((item) => {
        const file = obj[item.keyword as string];
        if (file) {
          nextFileList.push({
            facilityNo: context?.facilityNo,
            fileList_staffNo: context?.staffNo,
            formKbn: FormKbn["退職書類"],
            formClass:
              item.keyword === "identityDocs2"
                ? FormClassRetire["本人確認書類"]
                : item.id,
            formName: file[0].formName,
            file: file[0].fileBase64,
          });
        }
      });

    return nextFileList.map((item, index) => ({
      ...item,
      serialNo: index + 1,
    }));
  };

  const makeHttpObj = (obj: any): IAPI_RET005_Request => {
    const reqObj: IAPI_RET005_Request = {
      ...context,
      tempSaveStep: 8,
      contractorNo: businessState.common?.contractorNo,
      identificationDocsKind: obj.identifyDocsKind,
      fileList: makeFileObj(obj),
      screenId: "SCRR411126",
    };
    return API_RET005_BuildReqParams(reqObj);
  };

  const handleSubmit = async (data: any, index: any) => {
    switch (index) {
      case 0: // 一時保存
        // 退職手当金請求更新API実行
        try {
          const res = await httpAPI_RET005({
            ...makeHttpObj(data),
          });

          if (res.resultCd === "I0000") {
            setOpen(true);
            setBusinessState({
              ...businessState,
              job_41: {
                ...context,
                applyId: res.applyId,
                tempSaveStep: 8,
                identificationDocsKind: data.identifyDocsKind,
                fileList: makeFileObj(data),
              },
            });
            setState({
              ...state,
              errorMsgId: "",
            });
          } else {
            setState({
              ...state,
              errorMsgId: res?.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        setBusinessState({
          ...businessState,
          job_41: {
            ...context,
            identificationDocsKind: data.identifyDocsKind,
            fileList: makeFileObj(data),
          },
        });
        navigate("/SCRR410027");
        break;
    }
  };

  return (
    <Box data-testid="SCRR411126PageForTest">
      <TkStepper
        steps={stepper}
        activeStep={7}
        savaStep={context?.tempSaveStep}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLR411126_01}</TkInfoManual>
      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="退職者名"
          no={context?.retirementStaffName ?? ""}
        />
      )}
      <TkFakeTable
        list={stateTableList}
        ruleSchema={ruleSchema}
        submitButtonGroup={[
          {
            submitButtonText: "一時保存",
          },
          {
            submitButtonText: "次へ",
          },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={handleSubmit}
      />
      <TkMessageDialog
        open={open}
        onOky={() => setOpen(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411126;
